export const ADD_FEATURE_FLAGS = 'ADD_FEATURE_FLAGS';
